/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Calm_Finch_NestInputs */

const en_keen_calm_finch_nest = /** @type {(inputs: Keen_Calm_Finch_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leaf (no operator)`)
};

const de_keen_calm_finch_nest = /** @type {(inputs: Keen_Calm_Finch_NestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blatt (kein Operator)`)
};

/**
* | output |
* | --- |
* | "Leaf (no operator)" |
*
* @param {Keen_Calm_Finch_NestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_calm_finch_nest = /** @type {((inputs?: Keen_Calm_Finch_NestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Calm_Finch_NestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_calm_finch_nest(inputs)
	return de_keen_calm_finch_nest(inputs)
});